import { Component, HostListener, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonPadraoComponent } from '../../../shared/components/button-padrao/button-padrao.component';
import { FormFieldComponent } from '../../../shared/components/form-field/form-field.component';
import { SelectOneComponent } from '../../../shared/components/select-one/select-one.component';
import { MsgService } from '../../../shared/service/msg.service';
import { CustoMensagemWhatsapp } from '../../../shared/model/parametros/custo-mensagem-whatsapp.model';

@Component({
  selector: 'app-modal-cadastro-custo-whatsapp',
  standalone: true,
  imports: [CommonModule, ButtonPadraoComponent, FormFieldComponent, SelectOneComponent, ReactiveFormsModule, MatIcon],
  templateUrl: './modal-cadastro-custo-whatsapp.component.html',
  styleUrl: './modal-cadastro-custo-whatsapp.component.css'
})
export class ModalCadastroCustoWhatsappComponent implements OnInit {

  custo: CustoMensagemWhatsapp = new CustoMensagemWhatsapp();
  isCadastro = true;
  formCusto!: FormGroup;

  readonly opcoesPais = [
    { id: 'BR', nome: 'Brasil' },
    { id: 'US', nome: 'Estados Unidos' },
    { id: 'AR', nome: 'Argentina' },
    { id: 'CL', nome: 'Chile' },
    { id: 'MX', nome: 'México' }
  ];

  readonly opcoesCategoria = [
    { id: 'MARKETING', nome: 'Marketing' },
    { id: 'UTILITY', nome: 'Utilidade' },
    { id: 'AUTHENTICATION', nome: 'Autenticação' },
    { id: 'SERVICE', nome: 'Serviço' }
  ];

  readonly opcoesMoeda = [
    { id: 'BRL', nome: 'Real' },
    { id: 'USD', nome: 'Dólar' },
    { id: 'EUR', nome: 'Euro' }
  ];

  private readonly dialog = inject(MatDialogRef<ModalCadastroCustoWhatsappComponent>);
  public data = inject<any>(MAT_DIALOG_DATA);
  private readonly msgService = inject(MsgService);
  private readonly fb = inject(FormBuilder);

  constructor() {
    this.formCusto = this.fb.group({
      custo: [null, [Validators.required, Validators.min(0.0001)]],
    });
  }

  ngOnInit(): void {
    const custoRecebido = this.data?.['custo'];
    if (custoRecebido?.id) {
      this.custo = custoRecebido;
      this.isCadastro = false;
    } else {
      this.custo = new CustoMensagemWhatsapp();
      this.custo.moeda = 'USD';
      this.isCadastro = true;
    }

    this.formCusto.patchValue({
      custo: this.custo.custo,
    });
  }

  obterPais() {
    return this.opcoesPais.find(opcao => opcao.id === this.custo.codigoPais);
  }

  obterCategoria() {
    return this.opcoesCategoria.find(opcao => opcao.id === this.custo.categoriaCobranca);
  }

  obterMoeda() {
    return this.opcoesMoeda.find(opcao => opcao.id === this.custo.moeda);
  }

  selecionarPais(opcao?: { id: string }): void {
    if (opcao) this.custo.codigoPais = opcao.id;
  }

  selecionarCategoria(opcao?: { id: string }): void {
    if (opcao) this.custo.categoriaCobranca = opcao.id;
  }

  selecionarMoeda(opcao?: { id: string }): void {
    if (opcao) this.custo.moeda = opcao.id as 'BRL' | 'USD' | 'EUR';
  }

  salvar(): void {
    if (!this.custo.codigoPais) {
      this.msgService.msgAdvertencia('Selecione o país.');
      return;
    }
    if (!this.custo.categoriaCobranca) {
      this.msgService.msgAdvertencia('Selecione a categoria de cobrança.');
      return;
    }
    if (!this.custo.moeda) {
      this.msgService.msgAdvertencia('Selecione a moeda.');
      return;
    }
    if (this.formCusto.invalid) {
      this.formCusto.markAllAsTouched();
      this.msgService.msgAdvertencia('Termine de preencher os campos obrigatórios.');
      return;
    }

    this.custo.custo = this.formCusto.value.custo;

    this.dialog.close({ custo: this.custo });
  }

  cancelar(): void {
    this.dialog.close();
  }

  @HostListener('document:keydown.enter')
  handleEnterKey(): void {
    this.salvar();
  }
}
